import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AdminAuthStorageService } from './admin-auth-storage.service';

export const adminAuthGuard: CanActivateFn = () => {
  const storage = inject(AdminAuthStorageService);
  const router  = inject(Router);

  if (storage.hasToken()) return true;
  return router.parseUrl('/login');
};
